<template>
    <nav class="global-navigation">
      <ul class="product-nav" v-if="!isBookPage">
        <li v-for="(item, itemIndex) in getAgencyMenus.bookingPlatform.headerMenu" :key="itemIndex">
          <span v-if="item.link.startsWith('http')">
            <a :href="item.link" :title="item.title">{{item.title}}</a>
          </span>

          <span v-else>
            <router-link :to="`/${$i18n.locale}/` + item.link" :title="item.title">{{item.title}}</router-link>
          </span>
        </li>
      </ul>
    </nav>
</template>

<script>
import { auth } from "@/firebaseConfig";
import { mapGetters } from 'vuex'

export default {
  name: 'GlobalNavigation',

  data () {
    return {

    }
  },

  props: ['currentUser', 'isBookPage'],

  methods: {
    logout: function() {
      let self = this;
      self.$store.dispatch('setCurrentUser', null);
      auth.signOut().then(() => {
        self.$router.push('/admin/login')
      })
    }
  },

  computed: {
    ...mapGetters ([
      'getAgencyDisplay',
      'getAgencyMenus'
    ])
  }
}
</script>